import React, { useState } from "react";
import { Form, Button, Container } from "react-bootstrap";
import { v4 as uuidv4 } from "uuid";
import { FormField, FormPayload } from "../../../../service/types/types";
import { FormsService } from "../../../../service/forms.service";
import { FeedbackModal } from "../../../common/feedback.modal";
import FormFieldsEditor from "./formFieldsEditor";
import {useNavigate} from "react-router-dom";

export default function FormBuilder() {
  const [formName, setFormName] = useState("");
  const [isSignRequired, setIsSighnRequired] = useState(false);
  const [fields, setFields] = useState<FormField[]>([]);
  const [payload, setPayload] = useState<FormPayload>();

  //modal
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState<"success" | "error">("success");
  const [modalMessage, setModalMessage] = useState("");
  const navigate = useNavigate();

  const saveForm = async () => {
    if(formName == null || formName === "") {
      alert("nombre del formulario vacio");
      return;
    }
    else if(fields.length === 0){
      alert("ingrese al menos un campo");
      return;
    }
    const payload: FormPayload = {
      id: uuidv4(),
      name: formName,
      organization: 'm4',
      isSignRequired,
      fields,
    };
    setPayload(payload);
    try{
      await FormsService.create(payload);
      onSave(true);
      setTimeout(() => navigate(`/m4/form/list`), 2000);
    } catch (error: any) {
      onSave(false);
    }
  };
  
  const onSave = (isOk: boolean) => {
    if (isOk) {
      setModalType("success")
      setModalMessage("Lista Control Guardada Correctamente, Redireccionado a la lista de formularios")
    } else {
      setModalType("error")
      setModalMessage("Error Guardado Lista Control")
    }
    setShowModal(true);
  };

  return (
    <Container fluid className="p-4">

      <FeedbackModal
        show={showModal}
        onHide={() => setShowModal(false)}
        type={modalType}
        message={modalMessage}
        autoClose={true}   // 👈 se cierra solo en 3s
        duration={3000}
      />
      <h3>Crear Lista de Control</h3>
      <Form>
        <Form.Group className="mb-3 w-100">
          <Form.Label>Nombre Lista de Control</Form.Label>
          <Form.Control
            type="text"
            value={formName}
            required={true}
            onChange={e => setFormName(e.target.value)}
            placeholder="Ej: Encuesta de satisfacción"
          />
        </Form.Group>
        <Form.Group className="mb-3" controlId="isSignRequired">
          <Form.Check
            type="checkbox"
            label="¿Requiere firma?"
            name="isSignRequired"
            checked={isSignRequired}
            onChange={e => setIsSighnRequired(!isSignRequired)}
          />
        </Form.Group>
        <FormFieldsEditor fields={fields} onChange={setFields} />

        <br/>
        <Button variant="success" onClick={saveForm}>
          Guardar Formulario
        </Button>
      </Form>
      <br/>
    </Container>
  );
}